import React, { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import { IonIcon } from "@ionic/react";
import { 
  searchOutline, 
  closeOutline, 
  chevronDownOutline,
  checkmarkCircleOutline,
  radioButtonOffOutline
} from "ionicons/icons";
import { Typography, Card } from "@mui/joy";
import "./ModernDesplegable.css";

const ModernDesplegable = ({
  array = [],
  handleChange,
  mostrarTodos = false,
  mostrarSearch = true,
  label,
  id,
  value,
  isOpen,
  setIsOpen,
  placeholder,
  error,
  errorHelperText,
  helperText,
  disabled,
  className,
  style,
  cargando,
  emoji = "🔍",
  color = "#667eea",
  ...Props
}) => {
  const [texto, setTexto] = useState("");
  const [searchText, setSearchText] = useState("");
  const [opcionesValidas, setOpcionesValidas] = useState([]);
  const estabaAbiertoRef = useRef(false);

  const buscarTextoOpcion = (codigoOpcion) => {
    let texto = "";
    if (array && Array.isArray(array)) {
      array.forEach((item) => {
        if (item.codigo === codigoOpcion) texto = item.text;
      });
    }
    setTexto(texto);
  };

  const onHandleChange = (value, textLabel) => {
    handleChange(value, id);
    buscarTextoOpcion(value);
    setIsOpen(false);
    setSearchText("");
  };

  const FiltrarOpciones = (texto) => {
    if (array && Array.isArray(array)) {
      const opciones = array.filter((item) =>
        item.text.toLowerCase().includes(texto.toLowerCase())
      );
      setOpcionesValidas(opciones);
    } else {
      setOpcionesValidas([]);
    }
    setSearchText(texto);
  };

  useEffect(() => {
    // Solo se reinicia al abrir. Las opciones pueden cambiar de referencia al
    // renderizar la pantalla y no deben borrar una búsqueda que está en curso.
    if (isOpen && !estabaAbiertoRef.current && array && Array.isArray(array)) {
      setOpcionesValidas(array);
      setSearchText("");
    }
    estabaAbiertoRef.current = isOpen;
    buscarTextoOpcion(value);
  }, [isOpen, value, array]);

  return (
    <>
      {/* Campo de selección */}
      <div className={`modern-desplegable-container ${className}`} style={style}>
        <button
          type="button"
          className={`modern-desplegable-trigger ${error ? 'error' : ''} ${disabled ? 'disabled' : ''}`}
          onClick={() => !disabled && !cargando && setIsOpen(true)}
          disabled={disabled || cargando}
          style={{
            borderColor: error ? '#dc3545' : color,
            cursor: disabled || cargando ? 'not-allowed' : 'pointer',
            opacity: disabled || cargando ? 0.6 : 1
          }}
        >
          <div className="modern-desplegable-trigger-content">
            <span className="modern-desplegable-emoji">{emoji}</span>
            <div className="modern-desplegable-text">
              <span className="modern-desplegable-label">{label}</span>
              <span className="modern-desplegable-value">
                {texto || placeholder || "Seleccionar..."}
              </span>
            </div>
          </div>
          <IonIcon 
            icon={chevronDownOutline} 
            className={`modern-desplegable-icon ${isOpen ? 'open' : ''}`}
            style={{ color }}
          />
        </button>
        
        {(error && errorHelperText) && (
          <span className="modern-desplegable-error">{errorHelperText}</span>
        )}
        {(!error && helperText) && (
          <span className="modern-desplegable-helper">{helperText}</span>
        )}
      </div>

      {isOpen && ReactDOM.createPortal(
        <div className="modern-desplegable-overlay" onClick={() => setIsOpen(false)}>
          <div
            className="modern-desplegable-modal"
            onClick={(event) => event.stopPropagation()}
            style={{ '--accent-color': color }}
          >
            {/* Header */}
            <div className="modern-desplegable-header" style={{ background: `linear-gradient(135deg, ${color} 0%, ${color}dd 100%)` }}>
              <div className="modern-desplegable-header-content">
                <span className="modern-desplegable-header-emoji">{emoji}</span>
                <div>
                  <Typography 
                    level="h4" 
                    sx={{ color: 'white', fontWeight: 700, fontSize: '18px', margin: 0 }}
                  >
                    {label}
                  </Typography>
                  <Typography 
                    level="body-sm" 
                    sx={{ color: 'rgba(255,255,255,0.9)', fontSize: '13px', marginTop: '2px' }}
                  >
                    {array.length} opciones disponibles
                  </Typography>
                </div>
              </div>
              <button 
                type="button"
                className="modern-desplegable-close"
                onClick={() => setIsOpen(false)}
              >
                <IonIcon icon={closeOutline} />
              </button>
            </div>

            {/* Search Bar */}
            {mostrarSearch && (
              <div className="modern-desplegable-search">
                <IonIcon icon={searchOutline} className="modern-desplegable-search-icon" />
                <input
                  type="search"
                  className="modern-desplegable-search-input"
                  placeholder="Buscar..."
                  value={searchText}
                  onChange={(event) => FiltrarOpciones(event.target.value)}
                  autoFocus
                />
                {searchText && (
                  <button
                    type="button"
                    className="modern-desplegable-search-clear"
                    onClick={() => FiltrarOpciones("")}
                  >
                    <IonIcon icon={closeOutline} />
                  </button>
                )}
              </div>
            )}

            {/* Lista de opciones */}
            <div className="modern-desplegable-list">
              {mostrarTodos && (
                <button
                  type="button"
                  className={`modern-desplegable-item ${value === -1 ? 'selected' : ''}`}
                  onClick={() => onHandleChange(-1)}
                >
                  <div className="modern-desplegable-item-content">
                    <div className="modern-desplegable-item-icon">
                      <IonIcon 
                        icon={value === -1 ? checkmarkCircleOutline : radioButtonOffOutline}
                        style={{ color: value === -1 ? color : '#9ca3af' }}
                      />
                    </div>
                    <div className="modern-desplegable-item-text">
                      <span className="modern-desplegable-item-title">
                        🌟 Mostrar todos
                      </span>
                    </div>
                  </div>
                </button>
              )}

              {opcionesValidas && opcionesValidas.length > 0 ? (
                opcionesValidas.map((item) => (
                  <button
                    type="button"
                    key={item.codigo}
                    className={`modern-desplegable-item ${item.codigo === value ? 'selected' : ''}`}
                    onClick={() => onHandleChange(item.codigo)}
                  >
                    <div className="modern-desplegable-item-content">
                      <div className="modern-desplegable-item-icon">
                        <IonIcon 
                          icon={item.codigo === value ? checkmarkCircleOutline : radioButtonOffOutline}
                          style={{ color: item.codigo === value ? color : '#9ca3af' }}
                        />
                      </div>
                      {item.imageSrc && (
                        <div className="modern-desplegable-item-image-frame">
                          <img
                            src={item.imageSrc}
                            alt={item.text}
                            className="modern-desplegable-item-image"
                          />
                        </div>
                      )}
                      <div className="modern-desplegable-item-text">
                        <span className="modern-desplegable-item-title">
                          {item.text}
                        </span>
                        {item.note2 && (
                          <span 
                            className="modern-desplegable-item-note2"
                            style={{ color: item.note2Color || '#6b7280' }}
                          >
                            {item.note2}
                          </span>
                        )}
                        {item.note && (
                          <span className="modern-desplegable-item-note">
                            {item.note}
                          </span>
                        )}
                      </div>
                    </div>
                  </button>
                ))
              ) : (
                <div className="modern-desplegable-empty">
                  <IonIcon icon={searchOutline} className="modern-desplegable-empty-icon" />
                  <Typography level="body-md" sx={{ color: '#6b7280', marginTop: '8px' }}>
                    {searchText ? `No se encontraron resultados para "${searchText}"` : 'No hay opciones disponibles'}
                  </Typography>
                </div>
              )}
            </div>

            {/* Footer con contador */}
            <div className="modern-desplegable-footer">
              <Typography level="body-sm" sx={{ color: '#9ca3af' }}>
                {opcionesValidas.length} de {array.length} resultados
              </Typography>
            </div>
          </div>
        </div>,
        document.body
      )}
    </>
  );
};

export default ModernDesplegable;
